import { useState } from "react";
import { toast } from "react-toastify";
import { useExportIndividuals } from "./useExportIndividuals";
import { useExportIndividualsAdditionalData } from "./useExportIndividualAdditionalData";

export function useExportIndividualWithAdditionalData() {
  const [isLoading, setIsLoading] = useState(false);
  const individuals = useExportIndividuals();
  const additionalData = useExportIndividualsAdditionalData();

  const handleExport = async () => {
    setIsLoading(true);

    try {
      const results = await Promise.allSettled([
        individuals.handleExport(),
        additionalData.handleExport(),
      ]);

      const individualsSuccess = results[0].status === "fulfilled";
      const additionalDataSuccess = results[1].status === "fulfilled";

      if (!individualsSuccess && !additionalDataSuccess) {
        toast.error("Erro ao exportar relatórios do indivíduo");
        return;
      }
    } catch {
      toast.error("Erro ao exportar relatórios do indivíduo");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
